import React, { Component } from 'react';
import 'react-notifications-component/dist/theme.css';
import ReactNotification from 'react-notifications-component';
import { Route, Switch, Redirect, withRouter, RouteComponentProps } from 'react-router-dom';
import AppBar from './AppBar';
import { ThemeProvider } from '@material-ui/core/styles';
import routes, { BASE_URL } from '../../routes/index';
import ReactNotificationTrigger from '../../components/ReactNotificationTrigger';
import { ApplicationList } from '../../store/modules/application/types';
import PageNotFound from '../../components/PageNotFound';
import { EXPERIMENTAL, EXPERIMENTAL_ROUTES, FEATURE_ROUTES } from '../../store/app.constants';
import { Person } from '../../store/modules/person/types';
import theme from '../../assets/theme';

type AppProps = RouteComponentProps & {
    history: any;
    licenseListSearched: ApplicationList;
    searchLicense: Function;
    licenseListSearchedCount: number;
    siteTitle: string;
    featureFlags: string[];
    personListSearched: Person[];
};

type AppState = {};

class App extends Component<AppProps, AppState> {
    render() {
        const {
            history,
            licenseListSearched,
            searchLicense,
            licenseListSearchedCount,
            siteTitle,
            featureFlags,
            personListSearched,
        } = this.props;

        return (
            <div className="wrapper">
                <ReactNotification />
                <ReactNotificationTrigger />
                <ThemeProvider theme={theme}>
                    <AppBar
                        history={history}
                        licenseListSearched={licenseListSearched}
                        searchLicense={searchLicense}
                        licenseListSearchedCount={licenseListSearchedCount}
                        siteTitle={siteTitle}
                        featureFlags={featureFlags}
                        personListSearched={personListSearched}
                    />
                    <div className="page-wrapper">
                        <Switch>
                            {routes?.map((route) => {
                                if (
                                    (!featureFlags.includes(EXPERIMENTAL) &&
                                        EXPERIMENTAL_ROUTES.includes(route.title)) ||
                                    (FEATURE_ROUTES.includes(route.title) && !featureFlags.includes(route.title))
                                ) {
                                    return null;
                                } else {
                                    return <Route key={route.path} path={route.path} component={route.component} />;
                                }
                            })}
                            <Redirect exact from="/" to={BASE_URL} />
                            <Redirect exact from={BASE_URL} to={`${BASE_URL}/licenses`} />
                            <Route component={PageNotFound} />
                        </Switch>
                    </div>
                </ThemeProvider>
            </div>
        );
    }
}

export default withRouter(App);
